<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>Dozwolone adresy IP</h2>
      <ol class="breadcrumb">
        <li>
          <router-link to="/">Home</router-link>
        </li>
        <li class="active">
          <strong>Dozwolone adresy IP</strong>
        </li>
      </ol>
    </div>
  </div>

  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Dozwolone adresy IP</h5>
          </div>
          <div class="ibox-content">
            <router-link v-if="canAddIp" to="/ips/create">
              <button class="btn btn-sm btn-primary">Dodaj</button>
            </router-link>
            <div class="row">
              <div class="col-sm-12 m-b-xs">
                <div class="form-group">
                  <label class="control-label col-sm-2">
                    Wpisz liczbę wierszy:
                  </label>
                  <div class="col-sm-2">
                    <input
                      class="form-control inputClass"
                      type="text"
                      v-model="rowsPerPage"
                      @change="setRowsPerPage"
                      @click="isSearch = false"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 m-b-xs" v-if="items">
                <button @click="resetFilters" class="btn btn-primary btn-xs">
                  <i class="fa fa-refresh"></i>
                </button>
                <div class="pagination" v-if="itemsAll">
                  <span class="items-all">
                    Ilość rekordów: <b>{{ itemsAll }}</b>
                  </span>
                  <span>
                    Ilość na stronę:
                    <select v-model="serverOptions.rowsPerPage">
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </span>
                  <span>
                    <input type="number" v-model="serverOptions.page" /> -
                    {{ Math.ceil(itemsAll / serverOptions.rowsPerPage) }}
                  </span>
                  <button @click="selectPage(1)" class="btn btn-primary ml-25">
                    Pierwsza
                  </button>
                  <button
                    @click="serverOptions.page = serverOptions.page - 1"
                    :disabled="serverOptions.page === 1"
                    class="prev nl"
                  ></button>
                  <button
                    @click="serverOptions.page = serverOptions.page + 1"
                    :disabled="
                      serverOptions.page ===
                      Math.ceil(itemsAll / serverOptions.rowsPerPage)
                    "
                    class="next"
                  ></button>
                  <button
                    @click="
                      selectPage(
                        Math.ceil(itemsAll / serverOptions.rowsPerPage)
                      )
                    "
                    class="btn btn-primary"
                  >
                    Ostatnia
                  </button>
                </div>
                <EasyDataTable
                  v-model:server-options="serverOptions"
                  :server-items-length="itemsAll"
                  :headers="headers"
                  :items="items"
                  :clickRowToExpand="true"
                  :loading="loading"
                  @expand-row="editIp"
                  alternating
                  multi-sort
                  border-cell
                  @update-sort="updateSort"
                  class="table-search"
                >
                  <template #header="header">
                    <span v-if="header.text">{{ header.text }}</span>
                    <input
                      class="table-search"
                      type="text"
                      v-if="header.search"
                      v-model="searchValue[header.value]"
                      @keyup="search"
                      @click="isSearch = true"
                    />
                  </template>
                  <template #expand>
                    <div class="row">
                      <div class="col-lg-12">
                        <div class="ibox float-e-margins">
                          <div class="ibox-title">
                            <h5>Dozwolone adresy IP</h5>
                          </div>

                          <div class="form-horizontal">
                            <div class="ibox-content">
                              <div class="form-group">
                                <label
                                  for="username"
                                  class="control-label col-sm-2"
                                >
                                  Opis
                                </label>
                                <div class="col-sm-10 QuillEditor-box">
                                  <QuillEditor
                                    theme="snow"
                                    contentType="html"
                                    v-model:content="ipObj.description"
                                  />
                                  <div
                                    v-if="errorsAdminData?.data?.name"
                                    class="has-error"
                                  >
                                    <span class="help-block">
                                      {{ errorsAdminData.data.name[0] }}
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div class="form-group">
                                <label
                                  for="username"
                                  class="control-label col-sm-2"
                                >
                                  Adres IP
                                </label>
                                <div class="col-sm-10">
                                  <input
                                    v-model="ipObj.ip"
                                    name="ip"
                                    type="text"
                                    class="form-control inputClass"
                                    placeholder="Adres IP"
                                    required="required"
                                  />
                                  <div
                                    v-if="errorsAdminData?.data?.ip"
                                    class="has-error"
                                  >
                                    <span class="help-block">
                                      {{ errorsAdminData.data.ip[0] }}
                                    </span>
                                  </div>
                                </div>
                              </div>

                              <div class="hr-line-dashed"></div>

                              <div class="form-group">
                                <div class="col-sm-4 col-sm-offset-2">
                                  <button @click="cancel" class="btn btn-white">
                                    Anuluj
                                  </button>
                                  <button
                                    v-if="canChangeIp"
                                    @click="saveEdit"
                                    class="btn btn-primary"
                                  >
                                    Zapisz
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template #item-actions="item">
                    <button
                      v-if="canDeleteIp"
                      @click.stop="
                        showModal = item.pk;
                        deleteName = item.ip;
                      "
                      class="btn btn-danger btn-xs"
                    >
                      <i class="fa fa-trash"></i>
                    </button>
                    <template v-if="canChangeIp">
                      <button
                        @click="locked(item.pk, false)"
                        v-if="item.is_locked"
                        class="btn btn-danger btn-xs"
                        title="włącz"
                      >
                        <i class="fa fa-power-off"></i>
                      </button>
                      <button
                        v-else
                        @click="locked(item.pk, true)"
                        class="btn btn-danger btn-xs"
                        title="blokuj"
                      >
                        <i class="fa fa-ban"></i>
                      </button>
                    </template>
                  </template>
                </EasyDataTable>
                <div class="pagination" v-if="itemsAll">
                  <span class="items-all">
                    Ilość rekordów: <b>{{ itemsAll }}</b>
                  </span>
                  <span>
                    Ilość na stronę:
                    <select v-model="serverOptions.rowsPerPage">
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </span>
                  <span>
                    <input type="number" v-model="serverOptions.page" /> -
                    {{ Math.ceil(itemsAll / serverOptions.rowsPerPage) }}
                  </span>
                  <button @click="selectPage(1)" class="btn btn-primary ml-25">
                    Pierwsza
                  </button>
                  <button
                    @click="serverOptions.page = serverOptions.page - 1"
                    :disabled="serverOptions.page === 1"
                    class="prev nl"
                  ></button>
                  <button
                    @click="serverOptions.page = serverOptions.page + 1"
                    :disabled="
                      serverOptions.page ===
                      Math.ceil(itemsAll / serverOptions.rowsPerPage)
                    "
                    class="next"
                  ></button>
                  <button
                    @click="
                      selectPage(
                        Math.ceil(itemsAll / serverOptions.rowsPerPage)
                      )
                    "
                    class="btn btn-primary"
                  >
                    Ostatnia
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Modal
    v-if="showModal"
    :title="'Potwierdzenie usunięcia'"
    :content="'Czy na pewno chcesz usunąć <b>' + deleteName + '</b> ?'"
    @callbackOk="deleteIp(showModal)"
    @callbackClose="showModal = false"
  />
</template>

<script>
import { computed, watch, ref, onMounted } from "vue";
import { useStore } from "vuex";
import Modal from "../caffeprint/Modal.vue";
import { hasPermission } from "../../permissions";
import { allowedIpPermissionsConst } from "../../constants/ipConstants";

export default {
  name: "IpsList",
  mixins: [],
  components: {
    Modal,
  },
  props: {},

  setup() {
    const store = useStore();
    const deleteIpData = computed(() => store.getters.getDeleteIpData);
    const ipData = computed(() => store.getters.getIpData);
    const updateIpData = computed(() => store.getters.getUpdateIpData);
    const ipsData = computed(() => store.getters.getIpsData);
    const ipObj = ref({
      ip: "",
      description: "",
    });
    const canAddIp = computed(() =>
      hasPermission(allowedIpPermissionsConst.add)
    );
    const canChangeIp = computed(() =>
      hasPermission(allowedIpPermissionsConst.update)
    );
    const canDeleteIp = computed(() =>
      hasPermission(allowedIpPermissionsConst.delete)
    );
    let headers = [
      { text: "Nr", value: "pk" },
      {
        text: "IP",
        value: "ip",
        sortable: true,
        search: true,
      },
      {
        text: "Opis",
        value: "description",
        sortable: true,
        search: true,
      },
      { text: "Data utworzenia", value: "date_added", sortable: true },
      { text: "Data modyfikacji", value: "date_modified", sortable: true },
      {
        text: "Zmodyfikowano przez",
        value: "last_modified_by",
        sortable: false,
      },
      {
        text: "Utworzono przez",
        value: "created_by",
        sortable: false,
      },
      { text: "Ostatnie logowanie", value: "last_login_date", sortable: true },
      { text: "Akcje", value: "actions" },
    ];

    let items = ref([]);
    let statsItems = ref([]);
    let itemsAll = ref(0);
    const showModal = ref(false);
    const deleteName = ref("");
    const loading = ref(true);
    const searchValue = ref({});
    const isSearch = ref(false);
    const rowsPerPage = ref();
    const defRowsPerPage = ref(25);
    const serverOptions = ref({
      page: 1,
      rowsPerPage: defRowsPerPage,
    });

    const getIps = async () => {
      loading.value = true;
      let sort;
      if (serverOptions.value.sortType === "desc") {
        sort = "-" + serverOptions.value.sortBy;
      } else {
        sort = serverOptions.value.sortBy;
      }
      await store.dispatch("getIps", {
        page: serverOptions.value.page,
        itemsPerPage: serverOptions.value.rowsPerPage,
        ordering: sort,
        search: searchValue.value,
      });
    };

    const deleteIp = (pk) => {
      showModal.value = false;

      if (!canDeleteIp.value) {
        return;
      }

      store.dispatch("deleteIp", {
        pk: pk,
      });
    };
    const saveEdit = () => {
      if (!canChangeIp.value) {
        return;
      }

      store.dispatch("updateIp", ipObj.value);
    };

    const cancel = () => {
      document.querySelector(".expanding")?.click();
    };

    const editIp = (globalIndex) => {
      cancel();
      const localIndex =
        globalIndex - (serverOptions.value.page - 1) * defRowsPerPage.value;
      store.dispatch("getIp", { pk: items.value[localIndex].pk });
    };

    const search = () => {
      isSearch.value = true;
      if (searchValue.value) {
        selectPage(1);
        setTimeout(() => {
          getIps();
          isSearch.value = false;
        }, 1000);
      }
    };

    const resetFilters = () => {
      searchValue.value = {};
      serverOptions.value.sortBy = "";
      getIps();
    };

    const updateSort = () => {
      search.value = true;
    };

    // Locking an address writes to the record - the same permission the edit
    // form requires.
    const locked = (pk, val) => {
      if (!canChangeIp.value) {
        return;
      }

      store.dispatch("updateIp", {
        pk: pk,
        is_locked: val,
      });
    };

    const selectPage = (page) => {
      serverOptions.value.page = page;
    };

    const setRowsPerPage = () => {
      serverOptions.value.rowsPerPage = rowsPerPage.value;
    };

    onMounted(() => {
      if (localStorage.getItem("ipSearchValue") !== null) {
        searchValue.value = localStorage.getItem("ipSearchValue");
        searchValue.value = JSON.parse(searchValue.value);
      }
      getIps();
    });

    watch(
      () => searchValue.value,
      function () {
        localStorage.setItem(
          "ipSearchValue",
          JSON.stringify(searchValue.value)
        );
        getIps();
      },
      { deep: true }
    );

    watch(
      () => ipsData.value,
      function (newValue) {
        itemsAll.value = newValue.data.count;
        items.value = [];
        newValue.data.results?.forEach((element) => {
          items.value.push(element);
        });
        loading.value = false;
      }
    );

    watch(
      () => ipData.value,
      function (newValue) {
        ipObj.value = newValue.data;
      }
    );

    watch(
      () => deleteIpData.value,
      function (newValue) {
        if (newValue.status === 204) {
          store.dispatch("showToaster", {
            type: "success",
            content: "Adres IP został usunięty",
          });
        }
        getIps();
      }
    );

    watch(
      () => updateIpData.value,
      function (newValue) {
        if (newValue.status === 200) {
          getIps();
          store.dispatch("showToaster", {
            type: "success",
            content: "Dane zostały zaktualizowane",
          });
        }

        cancel();
      }
    );

    watch(
      () => serverOptions.value,
      function () {
        if (!isSearch.value) {
          getIps();
          isSearch.value = false;
        }
      },
      { deep: true }
    );

    return {
      headers,
      items,
      itemsAll,
      loading,
      canAddIp,
      canChangeIp,
      canDeleteIp,
      serverOptions,
      showModal,
      deleteIp,
      deleteName,
      statsItems,
      ipObj,
      cancel,
      editIp,
      saveEdit,
      searchValue,
      isSearch,
      rowsPerPage,
      resetFilters,
      updateSort,
      search,
      locked,
      selectPage,
      setRowsPerPage,
    };
  },
  computed: {},
};
</script>
